import { Component, Input } from '@angular/core'

@Component({
  selector: 'dmmp-back-to-top',
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.scss'],
})
export class BackToTopComponent {
  @Input() image: object
  @Input() module: any
  @Input() identifier: string
  medias = [{ style: 'large', media: '(min-width:421px)' }]

  scrollTop() {
    document.body.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    })
  }
}
